import axios from "axios";

//state
export var partnerState = {
  partners: [],
  partners_quiz: [],
  titles:[],
  partner: {},
  status_partner: ""
};

//getters
export var partnerGetters = {
  //funciones para optener informacion del state
  getPartners: state => state.partners,
  getPartnersQuiz: state => state.partners_quiz,
  getTitles: state=> state.titles,
  getSettingsPartners: (state) => state.partners,
  getPartnerInfo: (state) => state.partners,
  getPartnerReviewReplys: (state) => state.partners,
  getPartnerTemplates: (state) => state.partners,
  getPartnerAlarmWords: (state) => state.partners,
  updatePartnerData: (state) => state.partners,
};

var uid = localStorage.getItem("uid");
var pass = localStorage.getItem("pass");

//actions
export var partnerActions = {
    async updatePartnerData({ commit }, payload) {
        commit("partner_request");
        var {
                language,
                auto_reply_review,
                auto_reply_review_datetime,
                disabled,
                alarm_system,
                row_data
            }=payload;

        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'res.partner', 'write', [row_data], 
                   {
                       "language":language,
                       "auto_reply_review": auto_reply_review,
                       "auto_reply_review_datetime":auto_reply_review_datetime,
                       "disabled":disabled,
                       "alarm_system":alarm_system
                    },
                    ]
               }
           };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var partnerInfo = {};
                if(res.data.error){
                    commit("partner_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    partnerInfo = res.data.result;
                }
                commit("partner_success", partnerInfo);
                return res;
            })
            .catch(err => {
                commit("partner_error")
                return err;
            });
    },
    async getPartnerInfo({ commit }, payload) {
        commit("partner_request");
        var {
            partner_id
        }=payload;
        var domain = [];
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'res.partner', 'read', [partner_id], [] ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var partnerInfo = [];
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    partnerInfo = res.data.result;
                }
                commit("partner_success", partnerInfo);
                return res;
            })
            .catch(err => {
                commit("partner_error")
                return err;
            });
  },
  async getPartnerReviewReplys({ commit }, payload) {
        commit("partner_request");
        var {
            partner_id
        }=payload;
        var domain = [];
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.partner.review_reply', 'search_read', [['partner_id','=', partner_id]], [] ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                // console.log("res.data in account::", res.data);
                var partnerInfo = [];
                if(res.data.result.length > 0){
                    partnerInfo = res.data.result;
                }
                commit("partner_success", partnerInfo);
                return res;
            })
            .catch(err => {
                commit("partner_error")
                return err;
            });
  },
  async getPartnerTemplates({ commit }, payload) {
        commit("partner_request");
        var {
            partner_id
        }=payload;
        var domain = [];
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.partner.review_template', 'search_read', [['partner_id','=', partner_id]], [] ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                // console.log("res.data in account::", res.data);
                var partnerInfo = [];
                if(res.data.result.length > 0){
                    partnerInfo = res.data.result;
                }
                commit("partner_success", partnerInfo);
                return res;
            })
            .catch(err => {
                commit("partner_error")
                return err;
            });
  },
  async getPartnerAlarmWords({ commit }, payload) {
        commit("partner_request");
        var {
            partner_id
        }=payload;
        var domain = [];
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.partner.alarm_word', 'search_read', [['partner_id','=', partner_id]], [] ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                // console.log("res.data in account::", res.data);
                var partnerInfo = [];
                if(res.data.result.length > 0){
                    partnerInfo = res.data.result;
                }
                commit("partner_success", partnerInfo);
                return res;
            })
            .catch(err => {
                commit("partner_error")
                return err;
            });
  },
  async getSettingsPartners({ commit }) {
    commit("partner_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'res.partner', 'search_read', [], [], 0, 0, ""]
      }
    };

    await this._vm.$http
      .post("jsonrpc", req_data)
      .then((res) => {
        var getPartner_data = res.data.result;
        var getPartner = [];
        if (getPartner_data.length > 0) {
          getPartner = getPartner_data;
        }

        commit("partner_success", getPartner);
        return res;
      })
      .catch((err) => {
        commit("partner_error");
        return err;
      });
  },
  async getPartners({ commit }) {
    commit("partner_request");
    var req_data = {
         "jsonrpc": "2.0",
         "method": "call",
         "params": {
            service: 'object',
            method: 'execute',
                                                                                            // DOMAIN                     //FIELDS       //GROUPBY
            args: [axios.defaults.db, uid, pass, 'brand_whisper.review', 'read_group', [["partner_id","!=","false"]], ['partner_id'], ["partner_id"], 0,0,'',false ]
         }
     };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(res => {
        var partners =[];// res.data.result;
        res.data.result.forEach((partner)=>{

          if(partner.partner_id !== false){
            partners.push({
              "id":partner.partner_id[0], "value" : partner.partner_id[1]
          })
          }
        });
        commit("partner_success", partners);
        return res;
      })
      .catch(err => {
        commit("partner_error");
        return err;
      });
  },
  async getPartnersQuiz({ commit }) {
    commit("partner_request");
    var req_data = {
         "jsonrpc": "2.0",
         "method": "call",
         "params": {
            service: 'object',
            method: 'execute',
            args: [axios.defaults.db, uid, pass, 'apache.quiz', 'read_group', [["partner_id","!=","false"]], ['partner_id'], ["partner_id"], 0,0,'',false]
         }
     };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(res => {
        var partners =[];// res.data.result;
        res.data.result.forEach((partner)=>{

          if(partner.partner_id !== false){
            partners.push({
              "id":partner.partner_id[0], "value" : partner.partner_id[1]
          })
          }
        });
        commit("partner_quiz_success", partners);
        return res;
      })
      .catch(err => {
        commit("partner_error");
        return err;
      });
  }
};

//mutations

export var partnerMutations = {
  partner_request(state) {
    state.status_partner = "loading";
  },
  partner_success(state, payload) {
    state.status_partner = "success";
    state.partners = payload;
  },
  partner_quiz_success(state, payload) {
    state.status_partner = "success";
    state.partners_quiz = payload;
  },
  partner_error(state) {
    state.status_partner = "error";
  }
};
